export const NO_VALUE_PLACEHOLDER = "--";
export const ZIP_FILE_SUFFIX = ".zip";
export const CSV_FILE_SUFFIX = ".csv";
export const COMMUNICATION_ZIP_HEADER = "application/zip";
export const COMMUNICATION_CSV_HEADER = "text/csv";
export const TABLE_NO_DATA_MESSAGE = "No Data";
export const TABLE_WAITING_FOR_USER_CHOICES_MESSAGE = "Waiting for Your Choices...";
